import React from "react"
import Layout from "../../components/layout"
import LayoutNieuwsbrief from "../../components/layoutnieuwsbrief"
import Image1 from "../../images/nieuwsbriefjul2022/pic1.jpg"
import Image2 from "../../images/nieuwsbriefjul2022/pic2.jpg"
import Image3 from "../../images/nieuwsbriefjul2022/pic3.jpg"
import Image4 from "../../images/nieuwsbriefjul2022/pic4.jpg"
import Image5 from "../../images/nieuwsbriefjul2022/pic5.jpg"
import Image6 from "../../images/nieuwsbriefjul2022/pic6.jpg"
import Image7 from "../../images/nieuwsbriefjul2022/pic7.jpg"
import Image8 from "../../images/nieuwsbriefjul2022/pic8.jpg"
import Image9 from "../../images/nieuwsbriefjul2022/pic9.jpg"
import Image10 from "../../images/nieuwsbriefjul2022/pic10.jpg"
import Image11 from "../../images/nieuwsbriefjul2022/pic11.jpg"
import Image12 from "../../images/nieuwsbriefjul2022/pic12.jpg"
import Image13 from "../../images/nieuwsbriefjul2022/pic13.jpg"
import Image14 from "../../images/nieuwsbriefjul2022/pic14.jpg"
import Image15 from "../../images/nieuwsbriefjul2022/pic15.jpg"
import Image16 from "../../images/nieuwsbriefjul2022/pic16.jpg"
import Image17 from "../../images/nieuwsbriefjul2022/pic17.jpg"
import Image18 from "../../images/nieuwsbriefjul2022/pic18.jpg"
import Image19 from "../../images/nieuwsbriefjul2022/pic19.jpg"
import Image20 from "../../images/nieuwsbriefjul2022/pic20.jpg"
import Image21 from "../../images/nieuwsbriefjul2022/pic21.jpg"
import Image22 from "../../images/nieuwsbriefjul2022/pic22.jpg"
import Image23 from "../../images/nieuwsbriefjul2022/pic23.jpg"
import Image24 from "../../images/nieuwsbriefjul2022/pic24.jpg"
import Image25 from "../../images/nieuwsbriefjul2022/pic25.jpg"
import Image26 from "../../images/nieuwsbriefjul2022/pic26.jpg"
import Image27 from "../../images/nieuwsbriefjul2022/pic27.jpg"
import Image28 from "../../images/nieuwsbriefjul2022/pic28.jpg"
import Image29 from "../../images/nieuwsbriefjul2022/pic29.jpg"
import Image30 from "../../images/nieuwsbriefjul2022/pic30.jpg"
import Image31 from "../../images/nieuwsbriefjul2022/pic31.jpg"
import Image32 from "../../images/nieuwsbriefjul2022/pic32.jpg"
import Image33 from "../../images/nieuwsbriefjul2022/pic33.jpg"
import Image34 from "../../images/nieuwsbriefjul2022/pic34.jpg"

import { RowElement, ImageCentered, LeftAlignedImageBottom, LeftAlignedImage } from "../../components/imagecomponents"
import { OndertekeningZonderFunctieENG } from "../../components/snippets.js"
import Seo from "../../components/seo"

const Nieuwsbrief = () => (
  <Layout taal="engels">
    <Seo title="Newsletter July 2022" />

    <LayoutNieuwsbrief taal="engels">
      <h2>Newsletter July 2022</h2>

      <h3>Passed class 10 High School</h3>

      <p>
        All 29 students who applied for their Highschool diploma have passed with good results. Tribute to the teachers
        who, despite the corona problems, have achieved a fantastic result. And we also had two graduates for the Junior
        College. Congratulations everyone.{" "}
      </p>
      <br />
      <div style={{ display: "flex", flexWrap: "wrap" }}>
        <RowElement src={Image1} alt="" tekst="Ajay Narote" />
        <RowElement src={Image2} alt="" tekst="Anuja Raut" />
        <RowElement src={Image3} alt="" tekst="Aradhana Kulsange" />
        <RowElement src={Image4} alt="" tekst="Bhumika Basena" />
        <RowElement src={Image5} alt="" tekst="Chandan Netam" />
        <RowElement src={Image6} alt="" tekst="Deepmala Markam" />
        <RowElement src={Image7} alt="" tekst="Dyaneswhwar Uikey" />
        <RowElement src={Image8} alt="" tekst="Ganesh Salame" />
        <RowElement src={Image9} alt="" tekst="Janvi Pedam" />
        <RowElement src={Image10} alt="" tekst="Karan Uikey" />
        <RowElement src={Image11} alt="" tekst="Kanshish Kiodape" />
        <RowElement src={Image12} alt="" tekst="Lucky Vishwakarma" />
        <RowElement src={Image13} alt="" tekst="Minal Laade" />
        <RowElement src={Image14} alt="" tekst="Nayan Shingane" />
        <RowElement src={Image15} alt="" tekst="Neha Patel" />
        <RowElement src={Image16} alt="" tekst="Nitin Mishra" />
        <RowElement src={Image17} alt="" tekst="Prathna Sontakke" />
        <RowElement src={Image18} alt="" tekst="Rashmi Thakre" />
        <RowElement src={Image19} alt="" tekst="Sameer Bhoyar" />
        <RowElement src={Image20} alt="" tekst="Sanket Parteki" />
        <RowElement src={Image21} alt="" tekst="Sarika Pandhare" />
        <RowElement src={Image22} alt="" tekst="Saurabh Kakde" />
        <RowElement src={Image23} alt="" tekst="Shantanu Bawankar" />
        <RowElement src={Image24} alt="" tekst="Sheskumar Dongre" />
        <RowElement src={Image25} alt="" tekst="Snehal Edpate" />
        <RowElement src={Image26} alt="" tekst="Udit Uikey" />
        <RowElement src={Image27} alt="" tekst="Yash Maraskolhe" />
        <RowElement src={Image28} alt="" tekst="Yogesh Madavi" />
        <RowElement src={Image29} alt="" tekst="Yogesh Ojha" />
      </div>
      <br />
      <h3>Passed Junior College diploma</h3>
      <div style={{ display: "flex", flexWrap: "wrap" }}>
        <RowElement src={Image30} alt="" tekst="Ashish Korram" />
        <RowElement src={Image31} alt="" tekst="Sejal Shrivas" />
      </div>
      <br />
      <h3>WE ARE PROUD OF OUR ADULT STUDENTS</h3>
      <br />

      <LeftAlignedImageBottom src={Image32} alt="Simran, Isha, Saloni, Annelies" tekst="Simran, Isha, Saloni, Annelies">
        <p>
          We have been to India again. Three of the older orphans are now following the 3-year further nursing course
          via Nav-Jeevan. It was great to see how in the 2.5 years that we were not there due to corona, they have grown
          into self-confident young women. Saloni, who is in her final year, even worked in the corona department for a
          while and the second-year students Isha and Simran gained experience in the oncology department with
          palliative patients. And then we have the intelligent Anil who is in the final year of the BCCA bachelor's
          programme and will move on to the university master's programme in Computer Applications. We've seen watched
          them grow up all from very small people to young adults. And then to think that these are orphans who would
          still have lived on the street without Nav-Jeevan. You will understand how incredibly proud we are of them.
        </p>
      </LeftAlignedImageBottom>

      <p></p>

      <h3>New school year started</h3>
      <p>
        At the end of June, the new school year started. Only 147 children came on the first day. Corona has meant that
        many children did not return. However, we have 349 on the list that we expect to return. A few more appear every
        day. Teachers go after them but it takes a lot of time to reach them.
      </p>

      <h3>Construction of the hostel</h3>

      <LeftAlignedImage src={Image33}>
        <p>
          The construction of the new hostel is not easy. First we had to deal with a severe heat wave that lasted from
          late March to early June. With temperatures rising to 50 degrees, it was too hot to work on the construction
          site. Just after the heat wave, a period of incessant torrential rain began. If no other strange things
          happen, the prognosis is that the hostel will be ready in mid-September.
        </p>
      </LeftAlignedImage>

      <h3>We are not in a good financial poaition at the moment</h3>
      <p>
        Last year Tech Mahindra from India and the Foundation for advocacy for the young child stopped with the support
        of Nav-Jeevan. The Foundation for advocacy for the young child supported us for years, but they had to stop
        because their financial resources were exhausted. So far, we have been able to absorb that reasonably well.
      </p>
      <p>
        Unfortunately, we had to deal with another setback because the tribal department gave a much lower contribution
        than expected, € 7,000 instead of the expected € 50,000. The contribution of the tribal department is calculated
        on the basis of the number of days that the students were present. This is of course not really realistic, after
        all we do employ the teachers and they also had to provide online lessons. But the tribal department sticks to
        its rules. As a result, we could no longer pay the salaries.
        <br />
        Through donations from RATM BV and the Serra foundation, we have been able to solve this for the moment.
      </p>

      <h3>We need your help! </h3>

      <p>
        For example, it would be nice if each participant recruited one new donor. It's simple. Mail me his/her name,
        email address, bank account number and the monthly amount. I take care of everything else. This monthly
        donations can be stopped at any time. Of course, a one time donation is also very welcome. Mention if it is an
        employee of one of the Calder companies. The amount is then doubled by Calder.
      </p>
      <p>
        I would also like to ask you to bring Nav-Jeevan to the attention of your employer. Perhaps he wants to make a
        donation in the context of corporate social responsibility.
        <br />
        And maybe your child's school wants to do a project this year that they are still looking for a good charity
        for.
        <br />
        Or maybe you or one of your friends or family members wants to ask for a donation for Nav-Jeevan for his
        birthday or anniversary as a gift.
        <br />
        If you need leaflets, extra information or whatever for the recruitment, please let us know.
      </p>
      <br />
      <p>On behalf of the children and the staff of Nav-Jeevan Sanstha, we thank you again for your donations.</p>

      <ImageCentered src={Image34} />

      <OndertekeningZonderFunctieENG />

    </LayoutNieuwsbrief>
  </Layout>
)

export default Nieuwsbrief
